import { type PropsWithChildren, useEffect } from 'react';

import { PrivatePriceOverview } from '@/components/priceOverview/PrivatePriceOverview';
import { usePrivateItemPrice } from '@/hooks/usePrivateItemPrice';
import type { Money } from '../../../../../../../shared/frontend-resources/src/util/money';

export interface TjvrObjectPagePriceOverviewProps {
    itemId: number;
    startDate: Date;
    endDate: Date;
    numberOfGuests: number;
    setPrice?: (price: Money) => void;
}

export const TjvrObjectPagePriceOverview = ({
    itemId,
    startDate,
    endDate,
    numberOfGuests,
    setPrice,
}: PropsWithChildren<TjvrObjectPagePriceOverviewProps>) => {
    const { privateItemPrice: price, error, isLoading } = usePrivateItemPrice(itemId.toString(), startDate, endDate, numberOfGuests, null);

    useEffect(() => {
        if (price && setPrice) {
            setPrice(price.total);
        }
    }, [price]);

    return (
        <PrivatePriceOverview
            startDate={startDate}
            endDate={endDate}
            price={price}
            optionalCleaningDescription="Leietaker velger"
            error={error}
            isLoading={isLoading}
        />
    );
};
